export class AssignmentItem {
    private id:number;
    private name:string;
    private dateAssigned:Date;
    private dateCompleted:Date;
    private type:"Assessment"|"LibraryAsset";
    private resultId:string;
    
    public constructor() {
        this.name = "";
        this.dateAssigned = null;
        this.type = "Assessment";
    }

    public get Id() : number {
        return this.id;
    }

    public set Id(v:number) {
        this.id = v;
    }
    
    public get Name() : string {
        return this.name;
    }
    
    public set Name(v : string) {
        this.name = v;
    }
    
    
    public get DateAssigned() : Date {
        return this.dateAssigned;
    }
    
    public set DateAssigned(v : Date) {
        this.dateAssigned = v;
    }

    public get DateCompleted() : Date {
        return this.dateCompleted;
    }
    
    public set DateCompleted(v : Date) {
        this.dateCompleted = v;
    }
    
    public setDateAssigned(time:number) : Date {
        this.DateAssigned = new Date(time);
        return this.DateAssigned;
    }
    
    
    public get IsComplete() : boolean {
        return this.dateCompleted != null;
    }

    public get Type() : "Assessment"|"LibraryAsset" {
        return this.type;
    }

    public set Type(v:"Assessment"|"LibraryAsset") {
        this.type = v;
    }

    public get ResultId() : string {
        return this.resultId;
    }
    
    public set ResultId(v : string) {
        this.resultId = v;
        if (v !== null) {
            this.DateCompleted = new Date();
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/models/AssignmentItem.ts